class Helpers {

	static checkPropertiesExist(object, properties, show) {
		switch (typeof(properties)){
			case 'object':
				if (Array.isArray(properties))
				{
					for (var i = 0; i < properties.length; i++) {
						if(!object.hasOwnProperty(properties[i]))
							show ? console.warn('Property: ' + properties[i] + ' is not found') : null;
							return false;
					}
					return true;
				}
				else
				{	
					console.warn('Object property error: ' + properties);
					return false;
				}
			case 'string':
				show ? console.warn('Property: ' + properties + ' is not found') : null;
				return object.hasOwnProperty(properties);
			default:
				return false;
		}
	}

	static getLanguageFromUrl(urlOrPath = typeof window !== 'undefined' ? window.location.pathname : '') {
		let pathname = urlOrPath;

		try {
			if (urlOrPath.startsWith('http://') || urlOrPath.startsWith('https://')) {
				pathname = new URL(urlOrPath).pathname;
			}
		} catch (e) {
			pathname = urlOrPath;
		}

		var segments = pathname.split('/').filter(Boolean);
		var firstSegment = segments[0] ? segments[0].toLowerCase() : '';

		if (firstSegment === 'en') {
			return 'en';
		}

		return 'pl';
	}
}

export default Helpers;


// WEBPACK FOOTER //
// ./src/Components/Helpers/index.js